import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from "./priestScheduleReport.module.scss";
import { styled } from "@mui/material/styles";
import { isNil } from "lodash";
import { apiRequest } from "../../../infrastructure/backendService";
import { CustomInputLabel, CustomRadioButton, CommonButton, CustomMenuItem, CommonOutlinedButton } from "../../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";
import apiPath from "../../../config/apiPaths.json";


const CustomSelect = styled(Select)`
& svg {
    color: #F05802;
 }
 & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff;
    min-width: 0 !important;
 }
 & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
 }
 & fieldset {
    border-style: unset;
 }
`;
const PriestBookingConsolidatedReport = ({ sendDataToParent, getReportData }:any) => {
  const currentDate = new Date();
  const Months = [
    { id: "JAN", month: "January" },
    { id: "FEB", month: "February" },
    { id: "MAR", month: "March" },
    { id: "APR", month: "April" },
    { id: "MAY", month: "May" },
    { id: "JUN", month: "June" },
    { id: "JUL", month: "July" },
    { id: "AUG", month: "August" },
    { id: "SEP", month: "September" },
    { id: "OCT", month: "October" },
    { id: "NOV", month: "November" },
    { id: "DEC", month: "December" },
  ];

  var currentMonthNumber = currentDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
  const [selectedYear, setSelectedYear] = useState<any>(
    currentDate.getFullYear()
  );
  const [selectedMonthID, setSelectedMonthID] = useState<any>(
    currentMonthNumber
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [showWeekly, setShowWeekly] = useState<boolean>(false)
  const [selectedQuater, setSelectedQuater] = useState<string>("");
  const [showMonthly, setShowMonthly] = useState<boolean>(false);
  const [showQuaterly, setShowQuaterly] = useState<boolean>(false);
  const [showYearly, setShowYearly] = useState<boolean>(false);
  const [occuranceType, setOccuranceType] = useState<string>("");
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [Years, setYears] = useState<any>({});

  // const Years = [
  //   {
  //     year: 2023,
  //   },
  //   {
  //     year: 2024,
  //   },
  // ];
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/report-dashboard/yearList/INCOME_REPORT",
      includeToken: true,
    })
      .then((res) => {
        setYears(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const apiCall = () => {
    setLoading(true);
    const params = {
      selectedMonth: showMonthly ? selectedMonthID: "",
      selectedYear: selectedYear,
      monthRange: showQuaterly? selectedQuater: "",
    }
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.priestScheduleReports}/${occuranceType}`,
      params: params,
      includeToken: true,
    })
    
      .then((res: any) => {
        setLoading(false);
        setSearchButton(true);
        sendDataToParent(true,{occuranceType,params});
        const response = res?.data?.data?.map((obj:any)=>{
          return {
            "Priest Name":obj.priestName,
            "Temple Pooja(Hrs)":obj.templePoojaHrs,
            "No. of Temple Poojas":obj.templePoojaCount,
            "Outside Pooja(Hrs)":obj.outsidePoojaHrs,
            "No. of Outside Poojas":obj.outsidePoojaCount,
            "Priest Duties(Hrs)":obj.priestDutyHrs,
            "No. of Priest Duties":obj.priestDutyCount,
            "Total Pooja Hours":obj.totalPoojaHrs,
            "Total No. of Poojas":obj.totalPoojaCount,
            "Vacation/ Dayoff/ Other off hours":obj.vacationDayOff
          }
        })
        // getReportData(res?.data?.data);
        getReportData(response);
      })
      .catch((err: any) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handlesubmit = () => {
    apiCall();
  };

  const quaterlyYearsList = ["Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"];

  const handlequaterlyChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedQuater(event.target.value as string);
    setSearchButton(false);
  };

  const quaterlyYearsDropdown = () => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handlequaterlyChange}
          value={selectedQuater}
          placeholder="Please Select"
          MenuProps={{
            PaperProps: {
               sx: {
                  border: '1px solid #F05802',
                  '& ul': {
                     paddingTop: 0,
                     paddingBottom: 0,
                     overflowY: 'auto',
                     minHeight: 'auto',
                     maxHeight: '300px',
                     '&::-webkit-scrollbar': {
                        width: '8px',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: '#F3C539',
                        borderRadius: '6px',
                     },
                  },
               },
            },
         }}
        >
          {quaterlyYearsList.map((item, i) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const handleYearChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedYear(event.target.value as number);
    setSearchButton(false);
  };

  const handleMonthChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedMonthID(event.target.value as number);
    setSearchButton(false);
  };

  const YearsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handleYearChange}
          value={selectedYear}
          MenuProps={{
            PaperProps: {
               sx: {
                  border: '1px solid #F05802',
                  '& ul': {
                     paddingTop: 0,
                     paddingBottom: 0,
                     overflowY: 'auto',
                     minHeight: 'auto',
                     maxHeight: '300px',
                     '&::-webkit-scrollbar': {
                        width: '8px',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: '#F3C539',
                        borderRadius: '6px',
                     },
                  },
               },
            },
         }}
        >
          {Years.map((item:any, i:number) => (
            <CustomMenuItem value={item.year} key={i}>
              {item.year}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const MonthsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="month"
          onChange={handleMonthChange}
          value={selectedMonthID}
          MenuProps={{
            PaperProps: {
               sx: {
                  border: '1px solid #F05802',
                  '& ul': {
                     paddingTop: 0,
                     paddingBottom: 0,
                     overflowY: 'auto',
                     minHeight: 'auto',
                     maxHeight: '300px',
                     '&::-webkit-scrollbar': {
                        width: '8px',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: '#F3C539',
                        borderRadius: '6px',
                     },
                  },
               },
            },
         }}
        >
          {Months.map((item, i) => (
            <CustomMenuItem value={item.id} key={i}>
              {item.month}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const monthlyComponent = () => {
    return (
      <Grid container spacing={2} className={styles.dropdownConatiner}>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Month</CustomInputLabel>
          {MonthsDropdown()}
        </Grid>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Year</CustomInputLabel>
          {YearsDropdown()}
        </Grid>
      </Grid>
    );
  };

  const quaterlyComponent = () => {
    return (
      <Box className={styles.dropdownConatiner}>
        <Box>
          <CustomInputLabel>Search By Quarterly</CustomInputLabel>
          {quaterlyYearsDropdown()}
        </Box>
        <Box>
          <CustomInputLabel>Year</CustomInputLabel>
          {YearsDropdown()}
        </Box>
      </Box>
    );
  };

  const yearlyComponent = () => {
    return (
      <Box sx={{ width: "100%" }} className={styles.dropdownConatiner}>
        <Box>
          <CustomInputLabel>Search By Yearly</CustomInputLabel>
          {YearsDropdown()}
        </Box>
      </Box>
    );
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setSearchButton(false);
    // Update state based on the selected radio button
    switch (selectedValue) {
      case "Weekly":
        setShowWeekly(true);
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(false);
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Weekly")
        break;
      case "Monthly":
        setShowMonthly(true);
        setShowQuaterly(false);
        setShowWeekly(false);
        setShowYearly(false);
        setSelectedYear(currentDate.getFullYear());
        setSelectedQuater("");
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Monthly");
        break;
      case "Search By Quarterly":
        setShowMonthly(false);
        setShowQuaterly(true);
        setShowYearly(false);
        setShowWeekly(false);
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Quarterly");
        break;
      case "Search By Yearly":
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowWeekly(false);
        setShowYearly(true);
        setSelectedQuater("");
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Yearly");
        break;
      default:
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(false);
        setShowWeekly(false);
        setSelectedQuater("");
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthID(currentMonthNumber);
    }
  };

  const radioButtonsComponent = () => {
    return (
      <Box sx={{ marginBottom: "16px", display: "flex", flexDirection: "row", flexWrap:"wrap" }}>
        <FormControlLabel
          value="Weekly"
          label="Weekly"
          disabled={true}
          sx={{ '& .MuiSvgIcon-root': { color:"grey" }, cursor:"not-allowed" }}
          control={
            <CustomRadioButton
              checked={showWeekly}
              onChange={handleRadioChange}
            />
          }
        />
        <FormControlLabel
          value="Monthly"
          control={
            <CustomRadioButton
              checked={showMonthly}
              onChange={handleRadioChange}
            />
          }
          label="Monthly"
        />
        <FormControlLabel
          value="Search By Quarterly"
          control={
            <CustomRadioButton
              checked={showQuaterly}
              onChange={handleRadioChange}
            />
          }
          label="Quarterly"
        />
        <FormControlLabel
          value="Search By Yearly"
          control={
            <CustomRadioButton
              checked={showYearly}
              onChange={handleRadioChange}
            />
          }
          label="Yearly"
        />
      </Box>
    );
  };
  const renderComponent = () => {
    return (
      <>
        {showMonthly ? monthlyComponent() : ""}
        {showQuaterly ? quaterlyComponent() : ""}
        {showYearly ? yearlyComponent() : ""}
      </>
    );
  };

  const handleClear = () => {
    setSelectedMonthID("");
    setSelectedYear("");
    setSelectedQuater("");
  }

  return (
    <div>
      {radioButtonsComponent()}
      {renderComponent()}
      <Grid sx={{ mt: 3, display:"flex",gap:"16px" }}>
          <CommonButton
            sx={{ width: "fit-content", height: "38px" }}
            onClick={handlesubmit}
            disabled={searchButton || loading}
            id="submit"
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Submitting...
                </span>
              </>
            ) : (
              "Submit"
            )}
          </CommonButton>
          <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
        </Grid>
    </div>
  );
};

export default PriestBookingConsolidatedReport;
